import ReactOnRails from 'react-on-rails';
import axios from 'axios';
import SignupLogin from '../pages/SignupLogin';
import '../pages/SignupLogin/services/i18n';

const CsrfToken = document
  .querySelector('meta[name=csrf-token]')
  ?.getAttribute('content');

if (CsrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = CsrfToken;
}

ReactOnRails.register({ SignupLogin });
